import { StatsigClient } from '@statsig/js-client';
import { useMemo, useState } from 'react';

import { getStatsigEnvironment, statsigProductAccountUUIDKey } from './const';

// https://docs.statsig.com/client/javascript-sdk/react#asynchronous-initialization-network
export default function useAsyncClient(): {
  isLoading: boolean;
  client: StatsigClient;
} {
  const [isLoading, setIsLoading] = useState(true);

  const client = useMemo(() => {
    const instance = new StatsigClient(
      statsigProductAccountUUIDKey,
      {},
      {
        environment: getStatsigEnvironment(),
        customUserCacheKeyFunc: (key, user) => {
          return (
            key +
            user.userID +
            user.customIDs?.stableID +
            user.custom?.productUUID
          );
        },
      }
    );

    instance
      .initializeAsync()
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false));

    return instance;
  }, []);

  return { client, isLoading };
}
